import { useAuth } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

import { Spinner } from './ui/spinner';

export function RootRedirect() {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) return <Spinner />;
  if (isSignedIn) return <Navigate to="/app/projects" replace />;
  return <Navigate to="/sign-in" replace />;
}
